import { render } from "./toxbox-setting.vue?vue&type=template&id=e2d174f4"
import script from "./toxbox-setting.vue?vue&type=script&lang=js"
export * from "./toxbox-setting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__